import React from 'react';
import PropTypes from 'prop-types';
import Paginate from '../../../Paginate';
import ToolBar from '../../../ToolBar';
import styles from './styles.module.scss';

export default class Pagination extends React.Component {
  static propTypes = {
    page: PropTypes.number,
    pages: PropTypes.number,
    onPageChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    page: 0,
    pages: 1,
  };

  constructor(props) {
    super(props);

    this.state = {
      page: props.page,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ page: nextProps.page });
  }

  getSafePage = page => {
    const p = isNaN(page) ? this.props.page : page;
    return Math.min(Math.max(p, 0), this.props.pages - 1);
  };

  changePage = ({ selected }) => {
    const p = this.getSafePage(selected);
    this.setState({ page: p });

    if (this.props.page !== p) {
      this.props.onPageChange(p);
    }
  };

  render() {
    const { pages } = this.props;
    const { page } = this.state;

    return (
      <div className={styles['wrapper']}>
        <ToolBar align="right">
          <Paginate page={page} pageCount={pages} onPageChange={this.changePage} />
        </ToolBar>
      </div>
    );
  }
}
